import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { ProductDataSheet } from '../Model/Dto/ProductDataSheet';
import { StringResponse } from '../Model/Dto/StringResponse';

@Injectable()
export class ProductReportingService {
  constructor(private http: HttpClient) {

  }

  public getUrls(): Observable<string[]> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
    }
    return (this.http.get<string[]>("api/ReportDesigner/GetUrlsList", options)) as any;
  }

  public getFiles(customerId: string, backup: boolean = false): Observable<ProductDataSheet[]> {
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId).append("backup", backup)
    }
    return (this.http.get<ProductDataSheet[]>("api/Reporting/GetFileNames", options)) as any;
  }

  public deleteReport(data: ProductDataSheet): Observable<boolean> {
    
    return (this.http.post("api/Reporting/DeleteReport", data)) as any;
  }

  public renameReport(data: ProductDataSheet): Observable<boolean> {
    
    return (this.http.post("api/Reporting/RenameReport", data)) as any;
  }

  public restoreReportFromBackup(customerId: string, filename: string): Promise<StringResponse> {
    var filenameWithFileextension = filename + ".repx";
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId).append("backupFilename", filenameWithFileextension)
    }
    return lastValueFrom(this.http.post<StringResponse>("api/Reporting/RestoreReportFromBackup", null, options));
  }

}
